import { handleError } from '../../services/error-notification';
import {
  GlobalSearchModel,
  SearchOuterTabKeys,
  SearchProviderNames,
  getSearchModelStorageKey,
  initialGlobalSearchResults,
  searchGlobal,
} from './models/global-search';
import { SearchApi } from './search-api';
import { GlobalSearchViewDelegate } from './views/GlobalSearchView';

export class GlobalSearchController implements GlobalSearchViewDelegate {
  private model: GlobalSearchModel;

  private searchApi = new SearchApi();

  constructor(
    private updateViewState: (_: GlobalSearchModel) => void,
    initialModel?: GlobalSearchModel
  ) {
    this.model = initialModel ?? initialGlobalSearchResults();
  }

  private getModel = () => this.model;

  private update = (model: GlobalSearchModel) => {
    this.model = model;

    // save the state only if it's in a safe status
    if (model.status === 'idle' || model.status === 'loaded') {
      sessionStorage.setItem(getSearchModelStorageKey(), JSON.stringify(model));
    }

    this.updateViewState(model);
  };

  async onGlobalSearch(): Promise<void> {
    handleError(await searchGlobal(this.searchApi, this.getModel, this.update));
  }

  onSearchTermChange(term: string) {
    this.update({ ...this.model, inputValue: term });
  }

  clearSearchResults() {
    this.update({ ...this.model, ...initialGlobalSearchResults() });
  }

  onSelectTab(selectedTab: SearchProviderNames) {
    this.update({ ...this.model, selectedTab: selectedTab });
  }

  onSelectOuterTab(selectedOuterModalTab: SearchOuterTabKeys) {
    this.update({ ...this.model, selectedOuterModalTab });
  }
}
